module.exports = __webpack_public_path__ + "static/media/disconnectIcon.4cf2cf47.svg";